import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import NotFound from 'components/NotFound';
import OrderSidebar from 'components/OrderSidebar';
import OrderEditTabs from 'components/OrderEditTabs';
import PageWithSidebar from 'components/PageWithSidebar';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';

import { withData } from 'lib/relay';
import { OrderEditPageQuery } from '__generated__/OrderEditPageQuery.graphql';

const query = graphql`
  query OrderEditPageQuery($id: ID!) {
    order(id: $id) {
      name

      ...OrderEditTabs_order
      ...OrderSidebar_order
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<OrderEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [{ link: '/orders', name: 'Užsakymai' }];

const OrderEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { order } = usePreloadedQuery<OrderEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!order) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<OrderSidebar order={order} />}
      breadcrumbs={[...breadcrumbs, { name: order.name }]}>
      <OrderEditTabs order={order} />
    </PageWithSidebar>
  );
};

export default withData<OrderEditPageQuery, RouteParams>({
  query,
  loading: <EntityEditPageSkeleton breadcrumbs={breadcrumbs} />,

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(OrderEditPage);
